import React from 'react'
import Nav from './pages/Nav'
import Home from './pages/Home'
import Footer from './pages/Footer'

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import OneBHKInteriorDesigns from './pages/OneBHKInteriorDesigns';
import TwoBHKInteriorDesigns from './pages/TwoBHKInteriorDesigns';
import ThreeBHKInteriorDesigns from './pages/ThreeBHKInteriorDesigns';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import OutdoorDesigns from './pages/OutdoorDesigns';
import LandscapeDesigns from './pages/LandscapeDesigns';
import FurnitureDesigns from './pages/FurnitureDesigns';
import KitchenDesigns from './pages/KitchenDesigns';
import BedroomDesigns from './pages/BedroomDesigns';
import DiningRoomDesigns from './pages/DiningRoomDesigns';
import LivingRoomDesigns from './pages/LivingRoomDesigns';
import DecorativeUnitsDesigns from './pages/DecorativeUnitsDesigns';
import KidsRoomDesigns from './pages/KidsRoomDesigns';
import WhatWeDo from './pages/WhatWeDo';
import WhyMehome from './pages/WhyMehome';
import Gallery from './pages/Gallery';
import Blogs from './pages/Blogs';
import Carrers from './pages/Carrers';

const App = () => {
  return (
    <Router>
      {/* Navbar stays on all pages */}
      <Nav />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path='/about-us' element={<AboutUs />} />
        <Route path='/contact-us' element={<ContactUs />} />

        <Route path='/outdoor-designs' element={<OutdoorDesigns />} />
        <Route path='/landscape-designs' element={<LandscapeDesigns />} />
        <Route path='/furniture-designs' element={<FurnitureDesigns />} />

        <Route path='/one-bhk-interior-designs' element={<OneBHKInteriorDesigns />} />
        <Route path='/two-bhkinterior-designs' element={<TwoBHKInteriorDesigns />} />
        <Route path='/three-bhk-interior-designs' element={<ThreeBHKInteriorDesigns />} />

        <Route  path='/kitchen-designs' element={<KitchenDesigns />} />
        <Route path='/bedroom-designs' element={<BedroomDesigns />} />
        <Route path="/dining-room-designs" element={<DiningRoomDesigns />} />
        <Route path='/living-room-designs' element={<LivingRoomDesigns />} />
        <Route path='/decorative-units-designs' element={<DecorativeUnitsDesigns />} />
        <Route path='/kids-room-designs' element={<KidsRoomDesigns />} />


        <Route path='/what-we-do' element={<WhatWeDo />} />
        <Route path='/why-mehome' element={<WhyMehome />} />
        <Route path='/gallery' element={<Gallery />} />
        <Route path='/blogs'  element={<Blogs />} />
        <Route path='/carrers' element={<Carrers />} />
        
        
      </Routes>

      {/* Footer stays on all pages */}
      <Footer />
    </Router>
  )
}

export default App
